import aseanBusinessDefaultImage from "@assets/defaultImages/asean_business/default_image.jpeg";
import bTLuxeDefaultImage from "@assets/defaultImages/bt_luxe/default_BTLUXE.jpg";
import btgDefaultImaage from "@assets/defaultImages/btg/default_image.jpg";
import companiesMarketsDefaultImage from "@assets/defaultImages/companies-markets/default_image.jpg";
import bankingFinanceDefaultImage from "@assets/defaultImages/companies-markets_banking-finance/default_image.jpg";
import capitalMarketDefaultImage from "@assets/defaultImages/companies-markets_capital-markets-currencies/default_image.jpg";
import energyCommoditiesDefaultImage from "@assets/defaultImages/companies-markets_energy-commodities/default_image.jpg";
import reitsPropertyDefaultImage from "@assets/defaultImages/companies-markets_reits-property/default_image.jpg";
import telcosMediaTechDefaultImage from "@assets/defaultImages/companies-markets_telcos-media-tech/default_image.jpg";
import transportLogisticsDefaultImage from "@assets/defaultImages/companies-markets_transport-logistics/default_image.jpg";
import consumerHealthDefaultImage from "@assets/defaultImages/consumer_healthcare/default_image.jpg";
import eventsAwardsDefaultImage from "@assets/defaultImages/events-awards/default_image.jpg";
import garageDefaultImage from "@assets/defaultImages/garage/default_image.jpeg";
import globalEnterpriseDefaultImage from "@assets/defaultImages/global_enterprise/default_image.jpeg";
import internationalDefaultImage from "@assets/defaultImages/international/default_image.jpg";
import lifestyleDefaultImage from "@assets/defaultImages/lifestyle/default_Lifestyle.jpg";
import opinionFeaturesDefaultImage from "@assets/defaultImages/opinion_features/default_image.jpg";
import opinionFeaturesColumnsDefaultImage from "@assets/defaultImages/opinion-features_columns/default_image.jpg";
import opinionFeaturesFeaturesDefaultImage from "@assets/defaultImages/opinion-features_features/default_image.jpg";
import podcastsDefaultImage from "@assets/defaultImages/podcasts/default_podcasts.jpg";
import propertyDefaultImage from "@assets/defaultImages/property/default_image.jpeg";
import sgsmeDefaultImage from "@assets/defaultImages/sgsme/default_image.jpeg";
import singaporeDefaultImage from "@assets/defaultImages/singapore/default_image.png";
import singaporeEconomyPolicyDefaultImage from "@assets/defaultImages/singapore_economy-policy/default_image.jpg";
import startupsTechDefaultImage from "@assets/defaultImages/startups_tech/default_image.jpg";
import startupsTechTechnologyDefaultImage from "@assets/defaultImages/startups-tech_technology/default_image.jpg";
import wealthCryptoDefaultImage from "@assets/defaultImages/wealth_crypto-alternative-assets/default_image.jpg";
import wealthPersonalFinanceDefaultImage from "@assets/defaultImages/wealth_personal-finance/default_image.jpg";
import wealthWealthInvestingDefaultImage from "@assets/defaultImages/wealth_wealth-investing/default_image.jpg";
import workingLifeDefaultImaage from "@assets/defaultImages/working_life/default_image.jpg";

export const FALLBACK_DEFAULT_IMAGE = companiesMarketsDefaultImage;
export const DEFAULT_IMAGES: {
  key: string;
  thumbnail: string;
  label: string;
}[] = [
  {
    key: "international_asean",
    thumbnail: aseanBusinessDefaultImage,
    label: "Asean",
  },
  {
    key: "companies-markets_banking-finance",
    thumbnail: bankingFinanceDefaultImage,
    label: "Banking & Finance",
  },
  { key: "global", thumbnail: btgDefaultImaage, label: "BT Global" },
  {
    key: "lifestyle_bt-luxe",
    thumbnail: bTLuxeDefaultImage,
    label: "BT Luxe",
  },
  {
    key: "companies-markets_capital-markets-currencies",
    thumbnail: capitalMarketDefaultImage,
    label: "Capital Markets Currencies",
  },
  {
    key: "opinion-features_columns",
    thumbnail: opinionFeaturesColumnsDefaultImage,
    label: "Columns",
  },
  {
    key: "companies-markets",
    thumbnail: companiesMarketsDefaultImage,
    label: "Companies & Markets",
  },
  {
    key: "consumer-healthcare",
    thumbnail: consumerHealthDefaultImage,
    label: "Consumer & Healthcare",
  },
  {
    key: "wealth_crypto-alternative-assets",
    thumbnail: wealthCryptoDefaultImage,
    label: "Crypto & Alternative Assets",
  },
  {
    key: "singapore_economy-policy",
    thumbnail: singaporeEconomyPolicyDefaultImage,
    label: "Economy & Policy",
  },
  {
    key: "companies-markets_energy-commodities",
    thumbnail: energyCommoditiesDefaultImage,
    label: "Energy & Commodities",
  },
  {
    key: "events-awards",
    thumbnail: eventsAwardsDefaultImage,
    label: "Events & Awards",
  },
  {
    key: "opinion-features",
    thumbnail: opinionFeaturesDefaultImage,
    label: "Features",
  },
  {
    key: "opinion-features_features",
    thumbnail: opinionFeaturesFeaturesDefaultImage,
    label: "Features",
  },
  {
    key: "international_global",
    thumbnail: globalEnterpriseDefaultImage,
    label: "Global",
  },
  {
    key: "international",
    thumbnail: internationalDefaultImage,
    label: "International",
  },
  { key: "lifestyle", thumbnail: lifestyleDefaultImage, label: "lifestyle" },
  {
    key: "wealth_personal-finance",
    thumbnail: wealthPersonalFinanceDefaultImage,
    label: "Personal Finance",
  },
  { key: "podcasts", thumbnail: podcastsDefaultImage, label: "podcasts" },
  { key: "property", thumbnail: propertyDefaultImage, label: "Property" },
  {
    key: "companies-markets_reits-property",
    thumbnail: reitsPropertyDefaultImage,
    label: "Reits & Property",
  },
  { key: "singapore", thumbnail: singaporeDefaultImage, label: "Singapore" },
  { key: "singapore_smes", thumbnail: sgsmeDefaultImage, label: "SMES" },
  {
    key: "startups-tech_startups",
    thumbnail: garageDefaultImage,
    label: "Startups",
  },
  {
    key: "startups-tech",
    thumbnail: startupsTechDefaultImage,
    label: "Startups & Tech",
  },
  {
    key: "startups-tech_technology",
    thumbnail: startupsTechTechnologyDefaultImage,
    label: "Technology",
  },
  {
    key: "companies-markets_telcos-media-tech",
    thumbnail: telcosMediaTechDefaultImage,
    label: "Telcos, Media & Tech",
  },
  {
    key: "companies-markets_transport-logistics",
    thumbnail: transportLogisticsDefaultImage,
    label: "Transport & Logistics",
  },
  {
    key: "wealth_wealth-investing",
    thumbnail: wealthWealthInvestingDefaultImage,
    label: "Wealth & Investing",
  },
  {
    key: "working-life",
    thumbnail: workingLifeDefaultImaage,
    label: "Working Life",
  },
];

export const DEFAULT_IMAGES_STORYBOOK_MAPPING: Record<string, string> =
  Object.fromEntries(DEFAULT_IMAGES.map(({ label, key }) => [label, key]));
